import React, { useEffect, useState } from 'react'
import {
  ABSpinner,
  CompareResultsPageHeader,
  useErrorService,
} from '@abroad/components'
import { useParams, useHistory } from 'react-router-dom'
import API from '../utils/API'
import { Helmet } from 'react-helmet'

const contentWrapperClasses =
  'custom-offset-lg-1 custom-col-lg-12 px-lg-0 abroad-fs-exclude'

const SurveyCategory = () => {
  const { category } = useParams()
  const history = useHistory()
  const Error = useErrorService()
  const [isLoading, setIsLoading] = useState(true)
  const [surveyCategory, setSurveyCategory] = useState(null)

  const handleBack = () => {
    if (history.length > 1) {
      history.goBack()
    } else {
      history.replace('/admin/home')
    }
  }

  useEffect(() => {
    const getCategory = async () => {
      try {
        const { data } = await API.AdminAPI.companyList.getCategory(category)
        setSurveyCategory(data)
        setIsLoading(false)
      } catch (e) {
        setIsLoading(false)
        Error.showError(e)
        setTimeout(() => {
          history.replace('/admin/home')
        }, 3000)
      }
    }
    if (category) {
      getCategory()
    } else {
      history.replace('/admin/home')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category])

  return (
    <>
      <Helmet>
        <title>
          {surveyCategory?.title
            ? `${surveyCategory.title} | Abroad`
            : 'Survey Category | Abroad'}
        </title>
        <meta
          name='title'
          content={
            surveyCategory?.title
              ? `${surveyCategory.title} | Abroad`
              : 'Survey Category | Abroad'
          }
        />
        <meta
          property='og:title'
          content={
            surveyCategory?.title
              ? `${surveyCategory.title} | Abroad`
              : 'Survey Category | Abroad'
          }
        />
        <meta
          property='twitter:title'
          content={
            surveyCategory?.title
              ? `${surveyCategory.title} | Abroad`
              : 'Survey Category | Abroad'
          }
        />
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/survey/category/${category}`}
        />
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/survey/category/${category}`}
        />
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/survey/category/${category}`}
        />
      </Helmet>
      <main
        className={`wisdom-assessment survey-category-page ${contentWrapperClasses}`}>
        {isLoading && (
          <section>
            <ABSpinner />
          </section>
        )}
        {!isLoading && surveyCategory && (
          <>
            <CompareResultsPageHeader
              assessmentTitle='Awareness Assessment'
              pageTitle={surveyCategory?.title}
              onGoBack={handleBack}
            />
            <section>
              <div className='survey-category-panel bg-gray-300 space-y-5 px-lg-5 py-4'>
                <h3 className='text-gray-201 font-montserrat font-semibold mb-0'>
                  Overview
                </h3>
                <div
                  className='survey-category-content'
                  dangerouslySetInnerHTML={{
                    __html: surveyCategory?.description,
                  }}
                />
              </div>
            </section>
            {surveyCategory?.actionItems?.length > 0 &&
              surveyCategory.actionItems.map((item, index) => {
                if (index % 2 === 0) {
                  return (
                    <section key={index}>
                      <div className='survey-category-panel space-y-5 px-lg-5 pb-4 pt-5'>
                        {index === 0 && (
                          <h3 className='text-gray-201 font-montserrat font-semibold mb-0'>
                            Suggested Practices
                          </h3>
                        )}
                        <div
                          className='survey-category-content'
                          dangerouslySetInnerHTML={{
                            __html: item,
                          }}
                        />
                      </div>
                    </section>
                  )
                }
                return (
                  <section key={index}>
                    <div className='survey-category-panel bg-gray-300 space-y-5 px-lg-5 pb-4 pt-5'>
                      <div
                        className='survey-category-content'
                        dangerouslySetInnerHTML={{
                          __html: item,
                        }}
                      />
                    </div>
                  </section>
                )
              })}
          </>
        )}
        {!isLoading && !surveyCategory && (
          <section className='h-60 d-flex justify-content-center align-items-center'>
            <h4 className='font-montserrat font-semibold text-dark-600'>
              Please Enter a valid Category
            </h4>
          </section>
        )}
      </main>
    </>
  )
}

export default SurveyCategory
